<template>
  <div class="search">
    <div class="form-group">
      <span class="icon" />
      <input type="text">
      <input
        type="button"
        :value="buttonName"
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
      default: 'search',
    },
    buttonName: {
      type: String,
      default: '百度一下',
    },
  },
};
</script>

<style lang="scss" scoped>
.search{
  float: right;
}
.form-group{
  box-sizing: border-box;
  width: 274px;
  height: 36px;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(30, 60, 150, 0.06);
  text-align: left;
  font-size: 0;
  vertical-align: middle;
  .icon {
    display: inline-block;
    width: 10%;
    height: 100%;
    vertical-align: top;
    background-image: url("../../assets/icon/search_icon@2x.png");
    background-repeat: no-repeat;
    background-size: 14px 14px;
    background-position: center;
  }
  input[type=text] {
    width: 60%;
    height: 100%;
    outline: none;
    border: none;
    font-size: 14px;
  }
  input[type=button] {
    padding: 0;
    width: 30%;
    height: 100%;
    outline: none;
    border: none;
    background-color: #4865cd;
    color: #ffffff;
    font-size: 14px;
    cursor: pointer;
  }
}
</style>
